<template>
  <div class="option-toggle">
    <div class="descriptor">
      <h5 v-if="getT">{{getT.static.summary[0].location_label}}</h5>
      <p v-if="getT">
        {{
          $store.state.optionSelections.location.value === 'INDOOR'
            ? getT.options.location[0].indoor_text
            : getT.options.location[0].outdoor_text
        }}
      </p>
    </div>
    <div class="toggle-wrap">
      <button 
        v-for="(choice) in currPool.options.location.choices"
        v-bind:key="choice.id"
        class="toggle"
        :class="{ 'active': $store.state.optionSelections.location.value === choice.id }"
        v-on:click="setActive(choice.id)">
        <img :src="getIconUrl(choice)" :alt="choice.displayName">
      </button>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'OptionLocation',
  computed: {
    ...mapGetters(['getT', 'currPool']),
  },
  methods: {
    setActive(value) {
      this.$store.dispatch('updateOptionSelections', { name: 'location', value: value });
      // analytics
      this.$emit('clickedLocation', value);
    },
    getIconUrl(choice) {
      var icons = require.context('@/assets/icons/');
      return icons('./' + choice.icon);
    },
  },
}
</script>
<style scoped lang="scss">
.option-toggle {
  padding: .5rem .7rem .5rem 1rem;
  min-height: 4.5em;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid $deep-slate;
  .descriptor {
    h5 {
      min-width: 5em;
      color: white;
    }
    p {
      color: $muted-white;
      font-size: .8rem;
      letter-spacing: 1px;
    }
  }
  .toggle-wrap {
    max-width: 20em;
    padding-left: .5rem;
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-end;
    button.toggle {
      width: 50px;
      height: 50px;
      padding: 0;
      margin: .2rem;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: transparent;
      border: none;
      font-family: 'Europa Bold';
      cursor: default;
      &.active {
        background-color: $teal;
      }
      @media #{$desktop} {
        pointer: cursor;
        transition-duration: 200ms;
        &:not(.active):hover {
          background-color: lighten($navy, 4%);;
        }
      }
    }
  }
}
</style>
